(function () {
	'use strict';

	angular.module('app.leanProjects')
		.service('editProjectService', editProjectService);

	editProjectService.$inject = ['$rootScope', '$http', '$filter', '$translate', 'URLS'];

	function editProjectService($rootScope, $http, $filter, $translate, URLS) {
		return {
			getActivity: getActivity,
			getDetails: getDetails,
			uploadDocuments: uploadDocuments,
			getTasks: getTasks,
			getIssues: getIssues,
			getTeam: getTeam,
			getMetrics: getMetrics,
			getGeneral: getGeneral,
			getAreas: getAreas,
			getCurrentUserRoles: getCurrentUserRoles,
			deleteMember: deleteMember,
			addMember: addMember,
			editMember: editMember,
			getCategories: getCategories,
			getSuppliers: getSuppliers,
			getValueStreams: getValueStreams,
			editMetric: editMetric,
			deleteMetric: deleteMetric,
			addMetric: addMetric,
			getAllMetrics: getAllMetrics,
			getGoals: getGoals,
			getUsersNotInProject: getUsersNotInProject,
			getLastModified: getLastModified,
			getProjectTypes: getProjectTypes
		};

		function getActivity(projNdx, leanDirFactoryNdx, simpleFeed) {
			return $http.get(URLS.host + URLS.prefix + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/Activity')
				.then(getActivitySuccess, getActivityError);

			function getActivitySuccess(response) {
				var targetCurrency = response.data.targetCurrency;
				response.data = response.data.activity;
				for (var i = 0; i < response.data.length; i++) {
					var details = response.data[i].details ? JSON.parse(response.data[i].details) : '';
					response.data[i].type = response.data[i].action;
					switch (response.data[i].action) {
					case 'CREATE':
						response.data[i].action = $translate.instant('Added') + ' ';
						if (response.data[i].eventType === 'Attachment') {
							response.data[i].details = details[0].name;
						} else {
							response.data[i].details = $translate.instant(response.data[i].eventName);
						}
						response.data[i].details += '.';
						response.data[i].eventName = '';
						response.data[i].eventType = $translate.instant(response.data[i].eventType) + ':';
						break;
					case 'UPDATE':

						// Check if details exists
						if (!details || details.length === 0) {
							response.data[i].hide = true;
							continue;
						}

						response.data[i].action = $translate.instant('Edited') + ' ';

						// Don't show Project Name
						if (response.data[i].eventType === 'Project') {
							response.data[i].action = '';
							response.data[i].eventType = '';
							response.data[i].eventName = '';
						} else {
							response.data[i].eventName += ' - ';
							response.data[i].eventType = $translate.instant(response.data[i].eventType) + ':';
						}
						details = filterInvalidActivity(details);
						if (details.length === 1) {
							// Format Currency and Date
							if (details[0].type === 'currency') {
								details[0].new = $filter('currency')(details[0].new, targetCurrency, 0);
							} else if (details[0].type === 'date') {
								details[0].new = $filter('date')(details[0].new, 'mediumDate');
								if (details[0].modifiedBy) {
									details[0].new += ' (Caused by change to ' + details[0].modifiedBy.toLowerCase() + ' due date)';
								}
							}

							if (['description', 'action', 'Detailed Action', 'Actual Benefit Description', 'Target Benefit Description'].includes(details[0].field)) {
								response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Modified')+'&nbsp;</span>' + $translate.instant(capitalizeWord(details[0].field)) + '.' + '</span>';
							} else if(['targetSavingsMonthly', 'actualSavingsMonthly'].includes(details[0].field)) {
								response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Modified')+'&nbsp;</span>' + $translate.instant(camelCaseToTitleCase(details[0].field));

								try {
									var savings = JSON.parse(details[0].new);
									var savingsActivity = '';
									angular.forEach(savings, function(saving){
										savingsActivity += saving.yearMonth + ' to ' + $filter('currency')(saving.new, targetCurrency, 0) + ', ';
									});
									savingsActivity = savingsActivity.trim();
									if (savingsActivity.length > 1) {
										savingsActivity = savingsActivity.substr(0, savingsActivity.length - 1);
									}
									response.data[i].details += '<span class="bold">&nbsp;-&nbsp;</span>' + savingsActivity + '.' + '</span>';
								} catch(e) {
									response.data[i].details += '.</span>';
								}

							} else if(['Target Savings', 'Actual Savings'].includes(details[0].field)) {
								response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Modified')+'&nbsp;</span>' + $translate.instant(details[0].field);

								try {
									var savingsActivity = '';
									var savingsModes = JSON.parse(details[0].savingsModes);
									if (savingsModes && savingsModes.length) {
										savingsActivity += ': ';
										for (var j = 0; j < savingsModes.length; j++) { 
											var savings = savingsModes[j].new;
											var type = '';
											if (savingsModes[j].field.indexOf('not') > -1) {
												type += ' Not ';
											}
											type += ' Included in total: ';
											savingsActivity += (type + $filter('currency')(savings, targetCurrency, 0)).trim();
											if (savingsModes.length > 1 && j < savingsModes.length - 1) {
												savingsActivity += '<span class="bold">&nbsp;,&nbsp;</span>';
											}
										}
									}
									
									response.data[i].details += savingsActivity + '</span>';
								} catch(e) {
									response.data[i].details += '.</span>';
								}

							} else if ((details[0].field === 'categories' || details[0].field === 'goals') && details[0].new === '') {
								response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Removed')+'&nbsp;</span>' + 'all ' + $translate.instant(capitalizeWord(details[0].field)) + '.</span>';
							} else {
								response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Modified')+'&nbsp;</span>' + $translate.instant(capitalizeWord(details[0].field)) +
										'<span class="bold">&nbsp;'+ $translate.instant('to') +'&nbsp;</span>' + translateActivityValue(details[0].new) + '.' + '</span>';
							}
						} else if (details.length < 3 && details.length != 0) {
							var edited = '';
							edited += $translate.instant(capitalizeWord(details[0].field)) + ' ' + $translate.instant('and') + ' ' + $translate.instant(capitalizeWord(details[1].field)) + '.';
							response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Modified')+'&nbsp;</span>' + edited + '</span>';
						} else if (details.length >= 3) {
							var edited = '';
							edited += $translate.instant(capitalizeWord(details[0].field)) + ', ' + $translate.instant(capitalizeWord(details[1].field));
							if (details.length > 3) {
								edited += ' ' + $translate.instant('and') + ' ' + (details.length - 2).toString() + ' ' + $translate.instant('other(s)');
							} else {
								edited += ' ' + $translate.instant('and') + ' ' + $translate.instant(capitalizeWord(details[2].field));
							}
							edited += '.';
							response.data[i].details = '<span>' + '<span class="bold">'+$translate.instant('Modified')+'&nbsp;</span>' + edited + '</span>';
						} else {
							response.data[i].details = '';
						}
						response.data[i].detailsTitle = jQuery(response.data[i].details).text();
						response.data[i].description = response.data[i].eventName + response.data[i].details;
						if (simpleFeed) {
							response.data[i].details = response.data[i].details.split('&nbsp;' + $translate.instant('to') + '&nbsp;')[0];
						}
						break;
					case 'DELETE':
						response.data[i].action = $translate.instant('Deleted') + ' ';
						if (response.data[i].eventType === 'Attachment') {
							response.data[i].details = details[0].name;
						} else {
							response.data[i].details = $translate.instant(response.data[i].eventName);
						}
						response.data[i].details += '.';
						response.data[i].eventName = '';
						response.data[i].eventType = $translate.instant(response.data[i].eventType) + ':';
						break;
					default:
						break;
					}
					response.data[i].action += response.data[i].eventType;
					if (simpleFeed) {
						response.data[i].action = response.data[i].action.replace(':', '');
					}
					response.data[i].actualEventTime = _.clone(response.data[i].eventTime);
					response.data[i].eventTime = moment(response.data[i].eventTime).fromNow();
				}
				return response.data;
			}

			function getActivityError() {
				// TODO: Show some type of error message
			}
		}

		function getDetails(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projNdx;
			return $http.get(url)
				.then(getDetailsComplete)
				.catch(getDetailsFailed);

			function getDetailsComplete(response) {
				return response;
			}

			function getDetailsFailed(error) {
				return error;
			}
		}

		function uploadDocuments(projNdx, leanDirFactoryNdx, file, taskndx) {
			var fd = new FormData();
			fd.append('file', file);
			var url = URLS.host + URLS.prefix + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/Document';
			taskndx = taskndx || -1;
			if (taskndx > 0) {
				url += '?taskNdx=' + taskndx;
			}
			return $http.post(url, fd, {
				transformRequest: angular.identity,
				headers: {
					'Content-Type': undefined,
					'isFileUpload': true
				}
			}).then(uploadDocumentsSuccess, uploadDocumentsError);

			function uploadDocumentsSuccess(response) {
				response.message = $translate.instant('Attachment(s) Uploaded Successfully');
				response.isSuccessful = true;
				return response;
			}

			function uploadDocumentsError(response) {
				response.message = $translate.instant('Error Uploading Attachment(s)');
				response.isSuccessful = false;
				return response;
			}
		}

		function getTasks(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/Tasks';
			return $http.get(url)
				.then(getTasksListComplete)
				.catch(getTasksListFailed);

			function getTasksListComplete(response) {
				return response.data.data || [];
			}

			function getTasksListFailed(error) {
				return [];
			}
		}

		function getIssues(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/Issues';
			return $http.get(url)
				.then(getIssuesListComplete)
				.catch(getIssuesListFailed);

			function getIssuesListComplete(response) {
				return response.data;
			}

			function getIssuesListFailed(error) {
				return [];
			}
		}

		function getTeam(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + String.format(URLS.projectTeam, leanDirFactoryNdx, projNdx);
			return $http.get(url)
				.then(getTeamComplete)
				.catch(getTeamFailed);

			function getTeamComplete(response) {
				return response.data;
			}

			function getTeamFailed(error) {
				return [];
			}
		}

		function getMetrics(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + String.format(URLS.projectsMetrics, leanDirFactoryNdx, projNdx);
			return $http.get(url)
				.then(getMetricsComplete)
				.catch(getMetricsFailed);

			function getMetricsComplete(response) {
				return response.data;
			}

			function getMetricsFailed(error) {
				return [];
			}
		}

		function getGeneral(projNdx, leanDirFactoryNdx) {
			return $http.get(URLS.host + URLS.prefix + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/CustomFields')
				.then(getGeneralDetailsSuccess, getGeneralDetailsError);

			function getGeneralDetailsSuccess(response) {
				return response.data;
			}

			function getGeneralDetailsError(error) {
				return [];
			}
		}

		function getAreas(leanDirFactoryNdx, allAreas) {
			var url = URLS.host + String.format(URLS.projectAreas, leanDirFactoryNdx);
			if (allAreas) {
				url = url + '?allFactoryArea=' + allAreas;
			}
			return $http.get(url)
				.then(getAreasComplete)
				.catch(getAreasFailed);

			function getAreasComplete(response) {
				return response.data;
			}

			function getAreasFailed(error) {
				return [];
			}
		}

		function getCategories(leanDirFactoryNdx) {
			var url = URLS.host + String.format(URLS.projectCategories, leanDirFactoryNdx);
			return $http.get(url)
				.then(getCategoriesComplete)
				.catch(getCategoriesFailed);

			function getCategoriesComplete(response) {
				return response.data;
			}

			function getCategoriesFailed(error) {
				return [];
			}
		}

		function getCurrentUserRoles(projNdx, leanDirFactoryNdx) {
			var url = URLS.host + '2/factndx/' + leanDirFactoryNdx + '/LeanProject/' + projNdx + '/User/' + globalConfig.user.id + '/Roles';
			return $http.get(url)
				.then(getCurrentUserRolesComplete)
				.catch(getCurrentUserRolesFailed);

			function getCurrentUserRolesComplete(response) {
				var roleNames = [];
				for (var i = response.data.length - 1; i >= 0; i--) {
					roleNames.push(response.data[i].role);
				}
				return roleNames;
			}

			function getCurrentUserRolesFailed(error) {
				return [];
			}
		}

		function translateActivityValue(value) {
			if (value == null) {
				return value;
			}
			var text = String(value);
			if (['Started', 'Pending', 'Completed', 'Low', 'Medium', 'High', 'Critical'].indexOf(text) !== -1) {
				return $translate.instant(text);
			}
			return text;
		}

		function capitalizeWord(input) {
			return input.replace(/(?:^|\s)\S/g, function (a) {
				return a.toUpperCase();
			});
		}

		function camelCaseToTitleCase (str){
			return str[0].toUpperCase() + str.slice(1).replace(/([A-Z]+)/g, ' $1');
		}

		function deleteMember(projNdx, leanDirFactoryNdx, memberNdx, lastModified) {
			var url = URLS.host + String.format(URLS.deleteMember, leanDirFactoryNdx, projNdx) + memberNdx;
			return $http.delete(url, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(deleteMemberSuccess)
				.catch(deleteMemberFailed);

			function deleteMemberSuccess(response) {
				return 'Member deleted successfully';
			}

			function deleteMemberFailed(error) {
				var message = '';
				if (error && error.error) {
					message = error.error;
				} else if (error && error.data && error.data.error) {
					message = error.data.error;
				}
				return message;
			}
		}

		function addMember(projNdx, leanDirFactoryNdx, userObj, lastModified) {
			var url = URLS.host + String.format(URLS.deleteMember, leanDirFactoryNdx, projNdx);
			return $http.post(url, userObj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(addMemberSuccess)
				.catch(addMemberFailed);

			function addMemberSuccess(response) {
				return 'User added successfully';
			}

			function addMemberFailed(error) {
				var message = '';
				if (error && error.error) {
					message = error.error;
				} else if (error && error.data && error.data.error) {
					message = error.data.error;
				}
				return message;
			}
		}

		function editMember(projNdx, leanDirFactoryNdx, userObj, lastModified) {
			var url = URLS.host + String.format(URLS.deleteMember, leanDirFactoryNdx, projNdx);
			return $http.put(url, userObj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(editMemberSuccess)
				.catch(editMemberFailed);

			function editMemberSuccess(response) {
				return 'User role saved successfully';
			}

			function editMemberFailed(error) {
				var message = '';
				if (error && error.error) {
					message = error.error;
				} else if (error && error.data && error.data.error) {
					message = error.data.error;
				}
				return message;
			}
		}

		function getSuppliers(leanDirFactoryNdx) {
			var url = String.format(URLS.host + URLS.suppliersForInitiative, leanDirFactoryNdx);
			return $http.get(url)
				.then(getSuppliersComplete)
				.catch(getSuppliersFailed);

			function getSuppliersComplete(response) {
				return response.data;
			}

			function getSuppliersFailed(error) {
				return [];
			}
		}

		function getGoals(leanDirFactoryNdx) {
			var url = String.format(URLS.host + URLS.goals, leanDirFactoryNdx);
			return $http.get(url)
				.then(getGoalsComplete)
				.catch(getGoalsFailed);

			function getGoalsComplete(response) {
				return response.data;
			}

			function getGoalsFailed(error) {
				return [];
			}
		}

		function getValueStreams(leanDirFactoryNdx, projectNdx, metricNdx, valueStreamNdx) {
			var url = URLS.host + String.format(URLS.valueStreamsForMetric, leanDirFactoryNdx, projectNdx, metricNdx) + '?valueStreamNdx=' + valueStreamNdx;
			return $http.get(url)
				.then(getValueStreamsComplete)
				.catch(getValueStreamsFailed);

			function getValueStreamsComplete(response) {
				return response.data;
			}

			function getValueStreamsFailed(error) {
				return [];
			}
		}

		function editMetric(projNdx, leanDirFactoryNdx, metricObj, lastModified) {
			var url = URLS.host + String.format(URLS.editMetric, leanDirFactoryNdx, projNdx);
			return $http.put(url, metricObj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(editMetricSuccess)
				.catch(editMetricFailed);

			function editMetricSuccess(response) {
				return 'Metric value stream saved successfully';
			}

			function editMetricFailed(error) {
				var message = '';
				if (error && error.error) {
					message = error.error;
				} else if (error && error.data && error.data.error) {
					message = error.data.error;
				}
				return message;
			}
		}

		function deleteMetric(projNdx, leanDirFactoryNdx, metricNdx, valueStreamNdx, lastModified) {
			var url = URLS.host + String.format(URLS.deleteMetric, leanDirFactoryNdx, projNdx, metricNdx, valueStreamNdx);
			return $http.delete(url, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(deleteMetricSuccess)
				.catch(deleteMetricFailed);

			function deleteMetricSuccess(response) {
				return 'Metric deleted successfully';
			}

			function deleteMetricFailed(error) {
				var message = '';
				if (error && error.error) {
					message = error.error;
				} else if (error && error.data && error.data.error) {
					message = error.data.error;
				}
				return message;
			}
		}

		function addMetric(projNdx, leanDirFactoryNdx, metricObj, lastModified) {
			var url = URLS.host + String.format(URLS.editMetric, leanDirFactoryNdx, projNdx);
			return $http.post(url, metricObj, {
				headers: {
					'If-Unmodified-Since': lastModified
				}
			})
				.then(addMetricSuccess)
				.catch(addMetricFailed);

			function addMetricSuccess(response) {
				return 'Metric added successfully';
			}

			function addMetricFailed(error) {
				var message = '';
				if (error && error.error) {
					message = error.error;
				} else if (error && error.data && error.data.error) {
					message = error.data.error;
				}
				return message;
			}
		}

		function getAllMetrics(leanDirFactoryNdx) {
			var url = URLS.host + String.format(URLS.allMetrics, leanDirFactoryNdx);
			return $http.get(url)
				.then(getAllMetricsComplete)
				.catch(getAllMetricsFailed);

			function getAllMetricsComplete(response) {
				return response.data;
			}

			function getAllMetricsFailed(error) {
				return [];
			}
		}

		function getUsersNotInProject(leanDirFactoryNdx, projectNdx) {
			var url = URLS.host + String.format(URLS.usersNotInProject, leanDirFactoryNdx, projectNdx);
			return $http.get(url)
				.then(getUsersDataSuccess)
				.catch(getUsersDataError);

			function getUsersDataSuccess(response) {
				return response.data.map(function (user) {
					return {
						'name': user.firstName + ' ' + user.lastName,
						'id': user.ndx
					};
				});
			}

			function getUsersDataError() {
				return [];
			}
		}

		function getLastModified(projectNdx, leanDirFactoryNdx) {
			var url = URLS.host + String.format(URLS.lastModifiedForProject, leanDirFactoryNdx, projectNdx);
			return $http.get(url)
				.then(getLastModifiedSuccess)
				.catch(getLastModifiedFailed);

			function getLastModifiedSuccess(response) {
				return response.data;
			}

			function getLastModifiedFailed(error) {
				return undefined;
			}
		}
		
		function getProjectTypes(leanDirFactoryNdx) {
			var url = URLS.host + String.format(URLS.projectTypes, leanDirFactoryNdx);
			return $http.get(url)
				.then(getProjectTypesComplete)
				.catch(getProjectTypesFailed);

			function getProjectTypesComplete(response) {
				return response.data;
			}

			function getProjectTypesFailed(error) {
				return [];
			}
		}

		function filterInvalidActivity(activities) {
			var filteredData = _.remove(activities, function(activity) {
				return activity.field.toString() !== 'categoryIds' && 
						activity.field.toString() !== 'newCategories' && 
						activity.field.toString() !== 'goalIds';
			});
			return filteredData;
		}
	}
})();
